import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Tooltip as KTooltip } from '@progress/kendo-vue-tooltip';
import { computed, nextTick, onBeforeUnmount, onMounted, ref } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Tooltip',
  props: {
    position: { default: undefined },
    content: { default: undefined },
    color: { default: 'dark' },
    parentTitle: { type: Boolean, default: true },
    open: { type: Boolean, default: undefined },
    targetElement: { default: undefined },
    anchorElement: { default: 'target' },
    openDelay: { default: 750 },
    filter: { type: Function, default: undefined },
    zIndex: { default: 5 }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const tooltipRef = ref<
  InstanceType<typeof KTooltip> & {
    handleMouseOver: (e: MouseEvent) => void;
    handleMouseOut: (e: MouseEvent) => void;
  }
>();

const className = computed(() => {
  const classes = [`tooltip--${props.color}`];
  if (props.position === 'none') {
    classes.push('tooltip__no-callout');
  }
  return classes.join(' ');
});

let timeout: ReturnType<typeof setTimeout> | null = null;
const scheduleReposition = () => {
  if (timeout) clearTimeout(timeout);
  timeout = setTimeout(() => {
    if (tooltipRef.value && tooltipRef.value.currentOpen) {
      tooltipRef.value.resetPosition();
    }
  }, 100);
};

onMounted(() => {
  window.addEventListener('resize', scheduleReposition);

  if (props.open) {
    nextTick(() => {
      requestAnimationFrame(() => {
        scheduleReposition();
      });
    });
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('resize', scheduleReposition);
  if (timeout) clearTimeout(timeout);
});

__expose({
  handleMouseOver(event: MouseEvent | FocusEvent) {
    if (tooltipRef.value) {
      tooltipRef.value.handleMouseOver(event);
    }
  },
  handleMouseOut(event: MouseEvent | FocusEvent) {
    if (tooltipRef.value) {
      tooltipRef.value.handleMouseOut(event);
    }
  },
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(KTooltip), {
    ref_key: "tooltipRef",
    ref: tooltipRef,
    "open-delay": __props.openDelay,
    open: __props.open,
    position: __props.position == 'none' ? 'auto' : __props.position,
    "tooltip-class-name": className.value,
    "parent-title": __props.parentTitle,
    "anchor-element": __props.anchorElement,
    "target-element": __props.targetElement,
    filter: __props.filter,
    content: __props.content,
    "wrapper-style": { zIndex: __props.zIndex }
  }, _createSlots({
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    (__props.content)
      ? {
          name: __props.content,
          fn: _withCtx(() => [
            _renderSlot(_ctx.$slots, __props.content)
          ]),
          key: "0"
        }
      : undefined
  ]), 1032, ["open-delay", "open", "position", "tooltip-class-name", "parent-title", "anchor-element", "target-element", "filter", "content", "wrapper-style"]))
}
}

})